import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from "react-router"
import Cookies from 'js-cookie'
import Qs from 'query-string'

import { createMuiTheme } from '@material-ui/core/styles'
import { MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import ScrollToTop from 'components/common/ScrollTop'
import StaticPages from 'components/static/StaticPages'
import UnloginedStaticPages from 'components/static/UnloginedStaticPages'
import Member from 'components/Member'
import Loading from 'components/Loading'

import './i18n'

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#28b0b5',
            main: '#47c0bb',
            dark: '#47c0bb',
        }
    },
    overrides: {
        MuiTypography: {
            root: {
                color: '#4a4f55',
            }
        },
        MuiCssBaseline: {
            '@global': {
                body: {
                    backgroundColor: 'rgba(74, 79, 85, 0.08)'
                }
            }
        },
        MuiInputBase: {
            root: {
                color: '#4a4f55'
            }
        },
        MuiOutlinedInput: {
            inputMarginDense: {
                paddingTop: '10px',
                paddingBottom: '10px'
            },
            notchedOutline: {
                borderWidth: '2px'
            }
        },
        MuiButton: {
            root: {
                textTransform: 'none',
                fontSize: '1rem'
            },
            outlined: {
                color: 'rgba(0, 0, 0, 0.54)',
                letterSpacing: '0.2px',
                borderRadius: '5px',
                border: 'solid 2px rgba(74, 79, 85, 0.2)'
            },
            contained: {
                boxShadow: 'none',
                borderRadius: '5px',
                paddingTop: '7px',
                paddingBottom: '7px',
                border: 'solid 2px #47c0bb',
                '&$disabled': {
                    borderColor: '#F0F1F1'
                },
            },
            containedPrimary: {
                color: 'white'
            },
            fullWidth: {
                padding: '3px 0',
                textAlign: 'center',
            }
        },
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent'
                }
            }
        },
        MuiNativeSelect: {
            select: {
                '&:focus': {
                    backgroundColor: '#f3f3f3'
                }
            }
        },
        MuiCheckbox: {
            root: {
                color: 'rgba(0, 0, 0, 0.23)'
            }
        },
        MuiTab: {
            root: {
                fontSize: '1rem',
                fontWeight: 600,
                minWidth: '120px',
                '@media (min-width: 0px)': {
                    minWidth: '120px'
                }
            }
        },
        MuiTableHead: {
            root: {
                backgroundColor: '#e6e6e6',
                borderBottom: '1px solid rgba(74, 79, 85, 0.12)',
            }
        },
        MuiFormHelperText: {
            root: {
                fontSize: '0.875rem'
            }
        },
        MuiTableRow: {
            root: {
                backgroundColor: 'white'
            },
            hover: {
                '&:hover': {
                    backgroundColor: 'rgba(74, 79, 85, 0.05) !important'
                }
            }
        },
        MuiTableCell: {
            root: {
                paddingTop: '16px',
                paddingBottom: '16px',
                borderBottom: 0
            },
            body: {
                color: '#4a4f55',
                fontSize: '1rem'
            },
            head: {
                fontSize: '0.875rem',
                fontWeight: 400,
                color: '#9fa2a3',
            }
        },
        MuiAppBar: {
            root: {
                boxShadow: 'none',
            },
        }
    },
    typography: {
        body2: {
            color: '#4a4f55',
            fontWeight: 'normal'
        },
        fontSize: 14,
        h1: {
            color: '#0a1a1a',
            fontSize: '28px',
            fontWeight: 500
        },
        h2: {
            fontSize: '20px',
            fontWeight: 500
        },
        fontFamily: [
            '-apple-system',
            'Noto Sans',
            'Helvetica Neue',
            'Helvetica',
            'Nimbus Sans L',
            'Arial',
            'Liberation Sans',
            'PingFang SC',
            'Hiragino Sans GB',
            'Noto Sans CJK SC',
            'Source Han Sans SC',
            'Source Han Sans CN',
            'Microsoft YaHei',
            'Wenquanyi Micro Hei',
            'WenQuanYi Zen Hei',
            'ST Heiti',
            'SimHei',
            'WenQuanYi Zen Hei Sharp',
            'sans-serif'
        ].join(','),
        useNextVariants: true
    }
})

const staticPageUrl = ['/faq', '/price-detail', '/terms-of-use', '/update']

class App extends React.Component {
    constructor(props){
        super(props);
        this.entryUrl = this.props.location
    }

    componentDidMount() {
        if(!!this.props.location.search && !Cookies.get('memberSha')){
            this.props.history.push('/', 'loginPopup')
        }
    }

    componentWillReceiveProps(nextProps){
        const {
            member: { isLogin },
            history: { push },
        } = nextProps

        const urlSearch = this.entryUrl.search
        const urlPathname = this.entryUrl.pathname

        if(!this.props.member.isLogin && isLogin && !!urlSearch){
            const searchObj = Qs.parse(urlSearch)
            const searchMemberId = searchObj.memberId
            const accessDenied = Cookies.get('memberSha') !== searchMemberId
            switch (urlPathname) {
                case '/how-to-use':
                    push('/how-to-use', 2)
                    break;
                case '/member/order/detail':
                    if (accessDenied) {
                        push('/member/order')
                    } else {
                        push({
                            pathname: urlPathname,
                            search: urlSearch,
                        })
                    }
                    break;
                case '/member/inbound/detail':
                    if (accessDenied) {
                        push('/member/inbound')
                    } else {
                        push({
                            pathname: urlPathname,
                            search: urlSearch,
                        })
                    }
                    break;                    
                default:
                    push(urlPathname)
                    break;
            }
        }
    }

    isStaticPage = () => {
        const { location: { pathname } } = this.props;
        return staticPageUrl.some((url) => {
            const pattern = `^${url}`
            const regexp = new RegExp(pattern)

            return regexp.test(pathname)
        })
    }

    render() {
        const isLogin = this.props.member.isLogin
        const isCheckingLogin = this.props.member.isCheckingLogin

        if(isCheckingLogin){
            console.log('----------- App Loading --------------')
            console.log('isLogin', isLogin)
            return (<Loading isLoading={isCheckingLogin} />)
        }

        if(this.isStaticPage()){
            console.log('----------- Static Page --------------')
            console.log('isLogin', isLogin)
            return (
                <ScrollToTop>
                    <MuiThemeProvider
                        theme={theme}
                    >
                        <CssBaseline />
                        <StaticPages />
                    </MuiThemeProvider>
                </ScrollToTop>
            )            
        }

        console.log('----------- Member Page --------------')
        console.log('isLogin', isLogin)
        return (
            <MuiThemeProvider
                theme={theme}
            >
                <CssBaseline />
                {isLogin ? <Member /> : <UnloginedStaticPages />}
            </MuiThemeProvider>
        )
    }
}

const mapStateToProps = state => ({
    member: state.member,
    shippingCart: state.orders.shippingCart
})

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(App))
